import { isEthAddress } from '@/lib/launchpad/contracts'

const CANONICAL_ORIGIN = 'https://penguinpad.xyz'

export function colonyProfilePath(wallet?: string) {
  const value = wallet?.trim().toLowerCase() || ''
  if (!isEthAddress(value))
    return '/explore-colony'
  return `/colony/${value}`
}

export function colonyProfileUrl(wallet?: string) {
  return `${CANONICAL_ORIGIN}${colonyProfilePath(wallet)}`
}

export function parseColonyWallet(param?: string) {
  const value = param?.trim().toLowerCase() || ''
  return isEthAddress(value) ? value : ''
}
